import { ComponentPropsWithoutRef, ReactElement, VFC } from 'react';
import cn from 'classnames';

const MarginContainer: VFC<
  {
    padded?: boolean;
  } & ComponentPropsWithoutRef<'div'>
> = ({ padded = false, className, children, ...props }): ReactElement => (
  <div
    className={cn([
      'w-full max-w-[calc(1180px_+_40px)] mobile:max-w-[calc(1180px_+_80px)] mobile:px-8 tablet:max-w-[1280px] tablet:px-10',
      { 'px-4': padded },
      className,
    ])}
    {...props}
  >
    {children}
  </div>
);

export default MarginContainer;
